import { useRef } from 'react'

import { FilterAccordion, FiltersSharedProps } from '@avantstay/backoffice-core'

import { DatePicker, DatePickerProps } from '../../DatePicker'

type DatePickerFilterProps = FiltersSharedProps &
  Omit<DatePickerProps, 'onCancel'> & {
    title: string
    onClear?: () => void
  }

export const DatePickerFilter = ({
  title,
  value,
  metadata,
  allowOpenRange,
  onChange,
  onClear,
  ...otherProps
}: DatePickerFilterProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  const datePickerProps = { value, metadata, allowOpenRange, onChange } as DatePickerProps

  return (
    <FilterAccordion
      isDateRange
      ref={wrapperRef}
      title={title}
      filterValue={value}
      shouldShowClearButton={false}
      onClearFilter={onClear}
      {...otherProps}
    >
      <DatePicker {...datePickerProps} />
    </FilterAccordion>
  )
}
